export default __webpack_public_path__ + "static/media/searchByCoordinates.273fa38a.svg";